import { useState, useEffect } from 'react';
import axios from 'axios';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { useTheme } from '@mui/material/styles';
import background from '../assets/images/herobackground.png';
import HeroButtons from './HeroButtons';
import Spacer from './Spacer';

interface HeroProps {
  title: number;
  description: string;
}

const Hero = (): JSX.Element => {
  const theme = useTheme();

  const [hero, setHero] = useState<HeroProps[]>([]);

  const fetchHero = () => {
    axios
      .get<HeroProps[]>('http://120.46.135.166:8000/hero', {
        headers: {
          Accept: 'application/json',
        },
      })
      .then((response) => {
        setHero(response.data);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    fetchHero();
  }, []);

  return (
    <div id='home'>
      <Box
      sx={{
        paddingY: 10,
        paddingX: 2,
        backgroundImage: `url(${background})`, // Set the background image
        backgroundSize: 'cover', // Makes sure the image covers the entire box
        backgroundPosition: 'center', // Positions the image in the center
        backgroundRepeat: 'no-repeat', // Prevents the image from repeating
        height: '100vh', // You can set a height or keep it dynamic
      }}
    >
        {hero.slice(0, 1).map((item, i) => (
          <Container
            key={i}
            maxWidth='md'
            sx={{
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Box marginBottom={2}>
              <Typography
                align='center'
                color='black'
                variant='h3'
                sx={{ fontWeight: 700 }}
                gutterBottom
              >
                {item.title}
              </Typography>
            </Box>
            <Box marginBottom={3}>
              <Typography
                variant='h6'
                component='p'
                color='black'
                sx={{ fontWeight: 400 }}
              >
                {item.description}
              </Typography>
            </Box>
            <HeroButtons />
          </Container>
        ))}
      </Box>
      <Spacer sx={{ paddingTop: 6 }} />
    </div>
  );
};

export default Hero;
